/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetUploadByIdQueryResponse, SocialExportGetUploadByIdPathParams, SocialExportGetUploadById401, SocialExportGetUploadById403, SocialExportGetUploadById404 } from "../models/SocialExportGetUploadById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetUploadById } from "../axios/socialExportGetUploadById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetUploadByIdQueryKey = (id: SocialExportGetUploadByIdPathParams["id"]) => ["api-v2", { url: '/social-export/v1/upload/:id', params: {id:id} }] as const

export type SocialExportGetUploadByIdQueryKey = ReturnType<typeof socialExportGetUploadByIdQueryKey>

export function socialExportGetUploadByIdQueryOptions(id: SocialExportGetUploadByIdPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetUploadByIdQueryKey(id)
        return queryOptions<SocialExportGetUploadByIdQueryResponse, ResponseErrorConfig<SocialExportGetUploadById401 | SocialExportGetUploadById403 | SocialExportGetUploadById404>, SocialExportGetUploadByIdQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetUploadById(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns upload details including status, platform data, and available platform features.
 * @summary Get an upload by ID
 * {@link /social-export/v1/upload/:id}
 */
export function useSocialExportGetUploadById<TData = SocialExportGetUploadByIdQueryResponse, TQueryData = SocialExportGetUploadByIdQueryResponse, TQueryKey extends QueryKey = SocialExportGetUploadByIdQueryKey>(id: SocialExportGetUploadByIdPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetUploadByIdQueryResponse, ResponseErrorConfig<SocialExportGetUploadById401 | SocialExportGetUploadById403 | SocialExportGetUploadById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetUploadByIdQueryKey(id)
         

         const query = useQuery({
          ...socialExportGetUploadByIdQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetUploadById401 | SocialExportGetUploadById403 | SocialExportGetUploadById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}